import { Link, Typography } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import { Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { useCustomerSupport } from 'shared/helpers/CustomerSupport';
import { SuperPayInstantTransferConfirmDTO } from 'shared/modules/superpay/SuperPayDTO';
import styled from 'styled-components';

const BoxStyled = styled(Box)`
  flex-direction: column;
  gap: 24px;
`;

export function InstantTransferFailed({
  onClose,
  dialogConfirmInformation,
}: {
  onClose: () => void;
  dialogConfirmInformation: SuperPayInstantTransferConfirmDTO;
}) {
  const { showLauncherMessanger } = useCustomerSupport();

  return (
    <BoxStyled
      padding="medium"
      height="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Box padding="medium" backgroundColor="Red50" width="100%">
        <Stack space="small">
          <Box color="Red500">
            <Stack space="xsmall">
              <Cancel color="error" fontSize="large" />
              <Typography variant="h2">Instant Transfer Failed</Typography>
              <Typography>
                We couldn’t finish the transfer due to a bank error.
              </Typography>
              <Link
                component="button"
                color="textPrimary"
                onClick={() => {
                  showLauncherMessanger();
                }}
              >
                Contact Support
              </Link>
            </Stack>
          </Box>
          <Stack space="xxsmall">
            <Typography color="textSecondary">Account</Typography>
            <Typography>
              {dialogConfirmInformation.bank_account || 'No data'}
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Button fullWidth={isWebView} onClick={onClose}>
        Got It
      </Button>
    </BoxStyled>
  );
}
